import { openSnackbarError, openSnackbarInfo, openSnackbarWarning } from '../store/actions/requestAction';
import instance from "./axiosConfig";
import * as actionType from "../store/types";
import t from "../languages/pl";
import { tokenIdentifier } from '../utils/staticData';
import { getToken, removeToken } from './sessionData';

export const logout = dispatch => {
  removeToken();
  window.location.replace('/');

  dispatch({
    type: actionType.LOGOUT
  });
};

export function post(dispatch, url, data, callback, errorCallback) {

  let token = getToken();
  let config = {
    headers: { [tokenIdentifier]: token },
  };

  instance
    .post(url, data, config)
    .then(response => callback(response))
    .catch(error => {
      if (!!error && !!error.response && !!error.response.status && error.response.status === 401) {
        openSnackbarWarning(dispatch, t.unauthorizedError);
        logout(dispatch);
      } else if (!!error && !!error.response && !!error.response.status && (error.response.status === 402)) {
        openSnackbarWarning(dispatch, t.blockedUser);
      } else {
        if (!errorCallback)
          openSnackbarError(dispatch, t.serverError);
        else errorCallback(error.response);
      }
    });
}

export function get(dispatch, url, params = null, callback, errorCallBack = () => {
}) {

  let token = getToken();
  let config = {
    headers: { [tokenIdentifier]: token },
    params: params
  };

  instance
    .get(url, config)
    .then(response => callback(response))
    .catch(error => {
      if (!!error && !!error.response && !!error.response.status && error.response.status === 401) {
        openSnackbarWarning(dispatch, t.unauthorizedError);
        logout(dispatch);
      } else {
        openSnackbarError(dispatch, t.serverError);
        errorCallBack(error);
      }
    });
}

export function patch(dispatch, url, query, body, callback = () => {
}, errorCallback) {

  let token = getToken();
  let config = {
    headers: { [tokenIdentifier]: token },
    params: query,
  };

  instance
    .patch(url, body, config)
    .then(response => callback(response))
    .catch(error => {
      if (!!error && !!error.response && !!error.response.status && error.response.status === 401) {
        openSnackbarWarning(dispatch, t.unauthorizedError);
        logout(dispatch);
      } else {
        if (!errorCallback)
          openSnackbarError(dispatch, t.serverError);
        else errorCallback(error.response);
      }
    });
}

export function deleteReq(dispatch, url, data, callback = () => {
}, errorCallback = () => {
}) {

  let token = getToken();
  let config = {
    headers: { [tokenIdentifier]: token },
    params: data,
  };

  instance
    .delete(url, config)
    .then(response => callback(response))
    .catch(error => {
      if (!!error && !!error.response && !!error.response.status && error.response.status === 401) {
        openSnackbarWarning(dispatch, t.unauthorizedError);
        logout(dispatch);
      } else {
        openSnackbarError(dispatch, t.serverError);
        errorCallback(error);
      }
    });
}

export function put(dispatch, url, query, data, callback = () => {
}, errorCallback = () => {
}) {

  let token = getToken();
  let config = {
    headers: { [tokenIdentifier]: token },
    params: query
  };

  instance
    .put(url, data, config)
    .then(response => callback(response))
    .catch(error => {
      if (!!error && !!error.response && !!error.response.status && error.response.status === 401) {
        openSnackbarWarning(dispatch, t.unauthorizedError);
        logout(dispatch);
      } else {
        if (!errorCallback)
          openSnackbarError(dispatch, t.serverError);
        else errorCallback(error.response);
      }
    });
}

export function remove(dispatch, url, query, callback = () => {
}, errorCallback = () => {
}) {

  let token = getToken();
  let config = {
    headers: { [tokenIdentifier]: token },
    params: query
  };

  instance
    .delete(url, config)
    .then(response => {
      openSnackbarInfo(t.deletedSuccessfully);
      callback(response);
    })
    .catch(error => {
      if (!!error && !!error.response && !!error.response.status && error.response.status === 401) {
        openSnackbarWarning(dispatch, t.unauthorizedError);
        logout(dispatch);
      } else {
        if (!errorCallback)
          openSnackbarError(dispatch, t.serverError);
        else errorCallback(error.response);
      }
    });
}
